import * as Monitaro from '@/infrastructure/network/Monitaro/schema/models'
import { APIRequest } from '@/infrastructure/network/APIRequest'
import { HTTPMethod } from '@/infrastructure/network/types'

/**
 * 一斉通知一覧
 *
 * 病院で管理している一斉通知の一覧を返す
 */
export class FetchMessage implements APIRequest<Monitaro.FetchMessageResponse> {
  response: Monitaro.FetchMessageResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  params?: Monitaro.Query
  constructor(query?: Monitaro.Query) {
    this.params = query
    this.path = `/messages`
  }
}

/**
 * 一斉通知の作成と更新
 *
 * $request-&gt;usersがある場合、指定されたMRにのみ一斉通知を作成&lt;br&gt;
なかった場合は全員に配信か、指定した業種のみに配信するデータを作成&lt;br&gt;
ここでは保存のみで実際の送信は行わない。&lt;br&gt;
送信済みの場合は403を返す
 */
export class PostMessage implements APIRequest<Monitaro.PostMessageResponse> {
  response: Monitaro.PostMessageResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.POST
  params: Monitaro.MessageRequest
  constructor(params: Monitaro.MessageRequest) {
    this.params = params
    this.path = `/messages`
  }
}

/**
 * 一斉通知データの取得
 *
 * 指定された一斉通知のデータを返す
 */
export class GetMessage implements APIRequest<Monitaro.GetMessageResponse> {
  response: Monitaro.GetMessageResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.GET
  constructor(message: string) {
    this.path = `/messages/${message}`
  }
}

/**
 * 一斉通知データの更新
 *
 * 指定されたデータを更新する
 */
export class PutMessage implements APIRequest<Monitaro.PutMessageResponse> {
  response: Monitaro.PutMessageResponse
  path: string
  contentType = 'multipart/form-data'
  method = HTTPMethod.PUT
  params: Monitaro.MessageRequest
  constructor(message: string, params: Monitaro.MessageRequest) {
    this.params = params
    this.path = `/messages/${message}`
  }
}

/**
 * 一斉通知データの削除
 *
 * 送信前の一斉通知データを削除する
 */
export class DeleteMessage implements APIRequest<Monitaro.DeleteMessageResponse> {
  response: Monitaro.DeleteMessageResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.DELETE
  constructor(message: string) {
    this.path = `/messages/${message}`
  }
}

/**
 * 一斉通知送信
 *
 * 指定されたデータの一斉通知を行う
sendgridでリストに入るまでに5分のタイムラグがあるので、6分後に実行される様dispatchして処理する。
 */
export class PutSendMessage implements APIRequest<Monitaro.PutSendMessageResponse> {
  response: Monitaro.PutSendMessageResponse
  path: string
  contentType = 'application/json'
  method = HTTPMethod.PUT
  params: Monitaro.MessageSendRequest
  constructor(message: string, params: Monitaro.MessageSendRequest) {
    this.params = params
    this.path = `/messages/send/${message}`
  }
}
